import { Box, Typography } from '@mui/material';
import { generatePath, Link } from 'react-router-dom';
import { APP_URLS } from '../../routes/urls';
import { News } from '../../types/news';
import { getDefaultImageSrc, loadDefaultImageOnError } from '../../utils/image';
import { createExcerptFromArray } from '../../utils/text';
import { newsCardStyles } from './styles';

interface NewsCardProps {
  news: Pick<News, 'id' | 'media' | 'title' | 'publisher' | 'slug' | 'categories'>;
}

export const NewsCard: React.FC<NewsCardProps> = ({ news }) => {
  const categoryExcerpt = createExcerptFromArray(
    news.categories.map((category) => category.title),
    100
  );
  return (
    <Box component={Link} to={generatePath(APP_URLS.singleNews, { newsSlug: news.slug })} sx={newsCardStyles.card}>
      <Typography variant="medium" fontWeight="Medium" color="secondary">
        {categoryExcerpt}
      </Typography>
      <Box
        sx={newsCardStyles.image}
        component="img"
        src={news.media || getDefaultImageSrc('news')}
        onError={loadDefaultImageOnError.bind(null, 'news')}
        alt={news.title}
      />
      <Typography sx={{ mt: 2.5, mb: 0.5 }} variant="h6" component="h3">
        {news.title}
      </Typography>
      <Typography variant="medium" fontWeight="Medium">
        Publisher: {news.publisher}
      </Typography>
    </Box>
  );
};
